// Utility Libraries
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}


export function dynamicInput(sentence: any) {
  // Define a regex pattern to match double curly braces and their content
  var pattern = /\{\{([^}]+?)\}\}/g;

  // Use regex.exec to find all occurrences of the pattern in the sentence
  var matches = [];
  var match;
  while ((match = pattern.exec(sentence)) !== null) {
    matches.push(match[1].trim());
  }

  if (matches.length > 0) {
    // Return an array of content within the double curly braces
    return matches;
  } else {
    // Return null if no double curly braces are found in the sentence
    return null;
  }
}

export function parseJSONSafely(jsonString: any) {
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    const regex = /^```json\n|```$/g;
    return jsonString.replace(regex, "");
  }
}

